// extracted by mini-css-extract-plugin
export default {"TemplateGroupLabel":"_TemplateGroupLabel--XeQFp","TemplateGroupHeader":"_TemplateGroupHeader--yMDm8"};